import axios from 'axios';

const getSingleAccessEnabled = async ({
  userId,
}: {
  userId: string;
}): Promise<boolean> => {
  const { data } = await axios.get<boolean>(
    `/onboarding_portal_association/user/${userId}/single-access`,
  );

  return data;
};

export default getSingleAccessEnabled;
